import React, { useEffect, useState } from "react";
import { Sidebar, Segment, Dimmer, Loader } from "semantic-ui-react";
import { useHistory, useLocation } from "react-router-dom";

import SidebarMenu from "../side-navigation-menu/SidebarMenu";
import { Header } from "../header/header";
import TrialPeriodMessage from "../trialPeriodMessage/TrialPeriodMessage";
import SubscriptionRestrictedFeature from "../SubscriptionRestrictedFeature";

const Layout = ({
  children,
  isLoading,
  isLoggedIn,
  accountActions,
  history: historyProp,
}) => {
  const [collapsed, setCollapsed] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const location = useLocation();
  // Prefer router context history — routes.js recreates createBrowserHistory() each render,
  // so the prop can become stale and history.push won't update the active Router.
  const historyFromRouter = useHistory();
  const history = historyFromRouter || historyProp;

  const getUserRoleId = () => {
    try {
      const { WebStorage, WebStorageNames } = require("../../../utils");
      return WebStorage.getLocalStore(WebStorageNames.RoleId);
    } catch (e) {
      return localStorage.getItem("roleId");
    }
  };

  const userRoleId = getUserRoleId();
  const isAdmin = userRoleId && (parseInt(userRoleId, 10) === 1 || parseInt(userRoleId, 10) === 2);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.openHelpSupport = () => {
        if (history && typeof history.push === "function") {
          history.push("/help-support");
        } else {
          window.location.assign("/help-support");
        }
      };
    }
    return () => {
      if (typeof window !== "undefined") {
        delete window.openHelpSupport;
      }
    };
  }, [history]);

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      if (window.innerWidth <= 768) {
        setCollapsed(true);
      } else if (
        location.pathname.includes("/dashboard/time-off") ||
        location.pathname.includes("/dashboard/timeOff") ||
        location.pathname.includes("/dashboard/calender")
      ) {
        setCollapsed(true);
      } else {
        setCollapsed(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [location]);

  const getSidebarWidth = () => {
    if (!isLoggedIn) return 0;
    if (windowWidth <= 768) return 0;
    if (collapsed) return 72;
    return 260;
  };

  const sidebarWidth = getSidebarWidth();

  const isAuthPage =
    location.pathname === "/auth" ||
    location.pathname === "/login" ||
    location.pathname === "/register" ||
    location.pathname === "/forgot-password" ||
    location.pathname === "/onboarding";
  const isAppraisalRoute =
    location.pathname === "/appraisal" || location.pathname.startsWith("/appraisal/");

  if (isAuthPage) {
    return <>{children}</>;
  }

  return (
    <Sidebar.Pushable
      as={Segment}
      style={{
        minHeight: "100vh",
        border: "none",
        position: "relative",
        overflow: "hidden",
        width: "100%",
      }}
    >
      {isLoggedIn && (
        <SidebarMenu
          collapsed={collapsed}
          onToggle={toggleSidebar}
          isMobile={windowWidth <= 768}
        />
      )}

      <Sidebar.Pusher
        className="sidebar-pusher"
        style={{
          marginLeft: windowWidth <= 768 ? "0px" : `${sidebarWidth}px`,
          width: windowWidth <= 768 ? "100%" : `calc(100% - ${sidebarWidth}px)`,
          transition: "margin-left 0.3s ease, width 0.3s ease",
          padding: "0 10px",
        }}
      >
        <Dimmer.Dimmable
          as={Segment}
          dimmed={isLoading}
          style={{ border: "none", boxShadow: "none", padding: 0, background: "transparent" }}
        >
          <Dimmer active={isLoading} inverted>
            <Loader size="large">Loading</Loader>
          </Dimmer>
          <Header
            isLoading={isLoading}
            isLoggedIn={isLoggedIn}
            clickLogOut={() => accountActions.onLogOut()}
            history={history}
          />
          <div style={{ minHeight: "calc(100vh - 100px)", paddingBottom: "60px" }}>
            {isAppraisalRoute ? (
              <SubscriptionRestrictedFeature>{children}</SubscriptionRestrictedFeature>
            ) : (
              children
            )}
          </div>
          {isLoggedIn && isAdmin && (
            <TrialPeriodMessage contentAreaLeft={windowWidth <= 768 ? 0 : sidebarWidth} />
          )}
        </Dimmer.Dimmable>
      </Sidebar.Pusher>
    </Sidebar.Pushable>
  );
};

export default Layout;
